import { Context, ContextUtil } from './context';
import CiblerAPI from './ciblerApi';
import Utils from '../utils';
import Constants from '../constants';

export default class EligibilityWrapper {
  static checkEligibility = (callback) => {
    this.showOperation = callback;
    Utils.tryFunction(CiblerAPI.checkEligibility, [window.WIOCONFIG.disableMultiDisplay, this.onEligibleResponse()]);
    Utils.tryFunction(CiblerAPI.getTriggers, [this.onGetTriggerResponse]);
  };

  static isEligible = (d) => {
    if (!d.eligible) return false;

    // game campaigns are always displayed regardless of dailylocks or previous interactions
    if (d.campaignType === 'Game') return true;
    // display campaigns are always displayed if coolDown is 0
    if (d.campaignType === 'Display' && d.cooldown === 0) return true;

    const dailylock = localStorage.getItem('ciblerDailyLock');
    if (dailylock) {
    // if not enought time passed since last lock, no display
      if (Context.timestamp < dailylock - (-d.cooldown * 1000))
        return false;
    }

    const histo = Context.campaigns ? Context.campaigns[d.campaignId] : null;
    if (histo) {
      // no display after a refuse
      if (histo.refuseBlock) return false;
    }

    return true;
  }

  static onEligibleResponse = () => (result) => {
    const response = JSON.parse(result);
    let data = [];

    if (response.length) {
      if (!Context.trigger) { // when trigger, filter nothing
        for (let i = 0; i < response.length; i += 1) {
          const d = response[i];
          if (this.isEligible(d) && !document.querySelector(`#WioGameBg_${d.campaignId}`)) {
            data.push(d);
          }
        }
      } else {
        data = response.filter(r => r.eligible && !Context[r.campaignId] && !document.querySelector(`#WioGameBg_${r.campaignId}`));
      }
    }

    response.filter(r => !r.eligible).forEach((r) => {
      ContextUtil.update(['filterReasons', r.campaignId], r.filterReasons);
    });

    const vectorDTO = response.find(r => r.vector);
    if (vectorDTO) {
      Utils.storeVector(vectorDTO.campaignName);
    }

    if (!data || !data.length) return;

    if (window.WIOCONFIG.disableMultiDisplay) {
      this.handleCampaignEligible(data[0]);
    } else {
      data.forEach(d => this.handleCampaignEligible(d));
    }
  };

  static handleCampaignEligible = (data) => {
    window.WIO.track('eligible', data.campaignId);

    const campaignData = {
      prizeUUID: data.prizeUUID,
      behaviorUUID: data.behaviorUUID,
      campaignId: data.campaignId,
      sessionId: data.sessionId,
      giftDescription: data.giftDescription,
      successRateId: data.successRateId,
    };

    ContextUtil.update(data.campaignId, campaignData);
    window.WIO.track('eligibleProductView', true);

    CiblerAPI.getCampaignData(data.campaignId, data.userGroupId, this.onCampaignDataResponse);
  };

  static handleShowOperation = (param) => {
    Utils.tryFunction(this.showOperation, [param]);
  };

  static handleExit = (campaignId, evt) => {
    if (evt.toElement === null && evt.relatedTarget === null && evt.clientY < 0) {
      document.removeEventListener('mouseout', this.exitTriggerListener, { passive: true });
      this.handleShowOperation(campaignId); // campaignId
    }
  };

  static handleExitMobile = (campaignId) => {
    if (!this.prevScroll || this.prevScroll === undefined) this.prevScroll = 0;
    if ((this.prevScroll - window.scrollY) > 0) {
      document.removeEventListener('scroll', this.exitTriggerListener, { passive: true });
      this.handleShowOperation(campaignId);
      return;
    }
    this.prevScroll = window.scrollY;
  };

  static onCampaignDataResponse = campaignId => (data) => {
    const campaigndata = JSON.parse(data);
    ContextUtil.update([campaignId, 'campaigndata'], campaigndata);
    this.customCall(campaignId);

    const hashtrigger = () => {
      if (window.location.hash === '#ciblertrigger' || window.location.hash === 'ciblertrigger') {
        window.location.hash = '';
        this.handleShowOperation(campaignId);
      }
    };

    if (Utils.getQueryString('ciblerNoTrigger') === 'true') {
      setTimeout(() => this.handleShowOperation(campaignId), 50);
      return;
    }

    switch (Utils.getCampaignData(campaigndata.trigger, '')) {
      case 'exit':
        if (Context.device === 'mobile') {
          setTimeout(() => {
            this.exitTriggerListener = e => this.handleExitMobile(campaignId, e);
            document.addEventListener('scroll', this.exitTriggerListener, { passive: true });
          }, 1000);
          break;
        }
        setTimeout(() => {
          this.exitTriggerListener = e => this.handleExit(campaignId, e);
          document.addEventListener('mouseout', this.exitTriggerListener, { passive: true });
        }, 2000);
        break;
      case 'timer':
        setTimeout(
          () => this.handleShowOperation(campaignId),
          Utils.getCampaignData(campaigndata.triggertimer, 5000),
        );
        break;
      case 'anchor':
        hashtrigger();
        window.addEventListener('hashchange', hashtrigger, false);
        break;
      default:
        setTimeout(() => this.handleShowOperation(campaignId), 50);
        break;
    }
  };

  static getSrcUrl = (data) => {
    let iframeSrc = '';

    if (!data || !data.campaigndata) return iframeSrc;

    if (data.campaigndata.desktopUrl || data.campaigndata.mobileUrl) {
      iframeSrc = `${data.campaigndata.desktopUrl ? data.campaigndata.desktopUrl.value : data.campaigndata.mobileUrl.value}&endpoint=${Context.endpoint}`;

      if (Context.pid || Context.productName || Context.productImage) {
        iframeSrc = `${iframeSrc}&product=${Context.pid
        }&productname=${encodeURIComponent(Context.productName)
        }&productImg=${encodeURIComponent(Context.productImage)}`;
      }
      if (data.behaviorUUID) {
        iframeSrc = `${iframeSrc}&behaviorId=${data.behaviorUUID}`;
      }
    }
    if (Context.oauthOpen) {
      iframeSrc = `${iframeSrc}&cibler_auth=${encodeURIComponent(atob(decodeURIComponent(Utils.getQueryString('cibler_auth'))))}`;
    }
    return iframeSrc;
  };

  static onGetTriggerResponse = (result) => {
    const response = JSON.parse(result);
    sessionStorage.setItem('ciblerTriggerResult', result);

    if (!response || !response.length) return;

    if (!window.WIO.eligibilityTrigger) window.WIO.eligibilityTrigger = {};
    response.forEach((t) => {
      switch (t) {
        case 'ajout panier':
          window.WIO.eligibilityTrigger[Constants.EVENT.ADD_TO_BASKET] = t;
          break;
        default:
          break;
      }
    });
  }

  static customCall = () => false
}
